import Slider from '../../../libs/slider';

export default function ProductGalleryHandler(image_show_slider, image_thumb_slider) {
    function initThumbImageClickHandler() {
        [].forEach.call(image_thumb_slider.querySelectorAll('ul li'), function (li, index) {
            li.addEventListener('click', function () {
                imageSliderHandler.thumbCallbacks.onCurrentIndexChange(index);
                markSelectedImage(index);
            });
        });

        markSelectedImage(0);
    }

    function markSelectedImage(selectedIndex) {
        [].forEach.call(image_thumb_slider.querySelectorAll('ul li'), function (li, index) {
            const img = li.querySelector('img');
            if (index === selectedIndex) {
                img.classList.add('selected');
            } else {
                img.classList.remove('selected');
            }
        });
    }

    var imageSliderHandler = new function () {
        var prevented = false;

        var moveToFns = {
            show: function (pageIndex) {
            },
            thumb: function (pageIndex) {
            }
        };

        this.showCallbacks = {};
        this.showCallbacks.onCurrentIndexChange = function (pageIndex) {
            if (prevented) {
                prevented = false;
                return;
            }
            prevented = true;
            moveToFns.thumb(pageIndex);
            markSelectedImage(pageIndex);
        };
        this.showCallbacks.onExposeMoveTo = function (fn) {
            moveToFns.show = fn;
        };

        this.thumbCallbacks = {};
        this.thumbCallbacks.onCurrentIndexChange = function (pageIndex) {
            if (prevented) {
                prevented = false;
                return;
            }
            prevented = true;
            moveToFns.show(pageIndex);
            markSelectedImage(pageIndex);
        };
        this.thumbCallbacks.onExposeMoveTo = function (fn) {
            moveToFns.thumb = fn;
        };
        this.thumbCallbacks.onInitialized = function () {
            initThumbImageClickHandler();
        };
    }

    new Slider(image_show_slider, imageSliderHandler.showCallbacks);
    new Slider(image_thumb_slider, imageSliderHandler.thumbCallbacks);
}
